// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_UhD","cls2":"PaywallPage-cls2_hTx PaywallPage-cls1_UhD"};